import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { ScrollText } from "lucide-react";

const ACTION_COLORS = {
  create: "hsl(158 84% 39%)",
  update: "hsl(227 100% 33%)",
  delete: "hsl(0 78% 45%)",
  login: "hsl(220 10% 45%)",
  logout: "hsl(220 10% 45%)",
  verify: "hsl(158 84% 39%)",
  reject: "hsl(0 78% 45%)",
  complete: "hsl(38 92% 50%)",
  upload: "hsl(227 100% 33%)",
};

export default function Audit() {
  const { data: logs } = useQuery({
    queryKey: ["audit"],
    queryFn: async () => (await api.get("/audit")).data,
    refetchInterval: 20000,
  });

  return (
    <div className="p-4 md:p-8 max-w-5xl">
      <div className="mb-8">
        <div className="label-caps text-muted-foreground mb-2">Insights</div>
        <h1 className="font-display text-3xl md:text-4xl font-black tracking-tight">Audit Log</h1>
        <p className="text-sm text-muted-foreground mt-2">Immutable trail of every operational action.</p>
      </div>

      <div className="border border-border bg-card rounded-2xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted/40 border-b border-border">
              <tr>
                <th className="text-left px-4 py-3 label-caps text-muted-foreground">When</th>
                <th className="text-left px-4 py-3 label-caps text-muted-foreground">Actor</th>
                <th className="text-left px-4 py-3 label-caps text-muted-foreground">Action</th>
                <th className="text-left px-4 py-3 label-caps text-muted-foreground">Entity</th>
                <th className="text-left px-4 py-3 label-caps text-muted-foreground">IP</th>
              </tr>
            </thead>
            <tbody>
              {(logs || []).map((l) => (
                <tr key={l.id} className="border-b border-border last:border-0 hover:bg-accent/20" data-testid={`audit-${l.id}`}>
                  <td className="px-4 py-3 whitespace-nowrap font-mono text-xs">{new Date(l.at).toLocaleString()}</td>
                  <td className="px-4 py-3 text-xs">{l.user_email || "—"}</td>
                  <td className="px-4 py-3">
                    <Badge variant="outline" className="capitalize" style={{ borderColor: `${ACTION_COLORS[l.action] || "hsl(220 10% 60%)"}66`, color: ACTION_COLORS[l.action] || "hsl(220 10% 45%)" }}>
                      {l.action}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 text-xs">
                    <span className="capitalize">{l.entity_type}</span>
                    {l.entity_id && <span className="text-muted-foreground font-mono ml-1">#{l.entity_id.slice(0, 8)}</span>}
                  </td>
                  <td className="px-4 py-3 text-xs text-muted-foreground font-mono">{l.ip || "—"}</td>
                </tr>
              ))}
              {(!logs || logs.length === 0) && (
                <tr><td colSpan="5" className="p-12 text-center text-muted-foreground">
                  <ScrollText className="w-8 h-8 mx-auto mb-2" />
                  No audit entries yet.
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
